var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialMedia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M23.93 3.64011C23.78 3.08011 23.38 2.62011 22.84 2.41011C19.05 0.960109 12.77 1.00011 12.77 1.00011C12.77 1.00011 6.49 0.960109 2.69 2.41011C2.16 2.63011 1.75 3.08011 1.61 3.64011C1.35 4.66011 1 6.63011 1 10.0101C1 13.3901 1.35 15.3501 1.61 16.3701C1.76 16.9301 2.16 17.3901 2.7 17.6001C6.49 19.0501 12.77 19.0101 12.77 19.0101C12.77 19.0101 19.05 19.0401 22.84 17.6001C23.38 17.3801 23.78 16.9301 23.93 16.3701C24.19 15.3501 24.54 13.3801 24.54 10.0101C24.54 6.64011 24.19 4.66011 23.93 3.64011ZM10.96 13.6301V6.38011L16.39 10.0001L10.96 13.6301Z",
    fill: "#74B743"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3909 10.0099L10.9609 6.37988V13.6299L16.3909 10.0099Z",
    stroke: "#74B743",
    strokeWidth: 1.8111,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 10.01C1 13.38 1.35 15.35 1.61 16.37C1.76 16.93 2.16 17.39 2.7 17.6C6.49 19.05 12.77 19.01 12.77 19.01C12.77 19.01 19.05 19.04 22.84 17.6C23.38 17.38 23.78 16.93 23.93 16.37C24.19 15.35 24.54 13.38 24.54 10.01C24.54 6.63997 24.19 4.66997 23.93 3.64997C23.78 3.08997 23.38 2.62997 22.84 2.41997C19.05 0.969974 12.77 1.00997 12.77 1.00997C12.77 1.00997 6.49 0.959974 2.69 2.40997C2.16 2.62997 1.75 3.07997 1.61 3.63997C1.35 4.65997 1 6.62997 1 10.01Z",
    stroke: "#74B743",
    strokeWidth: 1.8111,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialMedia);
export default __webpack_public_path__ + "static/media/socialMedia.12f1a6feb42e8778777578b9e62f00ae.svg";
export { ForwardRef as ReactComponent };